import MainLayout from "./MainLayout";
import { Globe, Mail, X } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <MainLayout>
      {/* Top Banner */}
      <section className="w-full bg-black text-white py-20">
        <h1 className="text-center text-5xl md:text-7xl font-extrabold text-gray-200 leading-tight pt-2">
          Privacy Policy
        </h1>
      </section>

      {/* Content Section */}
      <section className="max-w-4xl mx-auto px-6 md:px-12 text-lg text-gray-300 space-y-8 text-left">
        <span style={{ color: "#cca1e4", fontSize: "20px" }}>
            XynexAI – Privacy Policy
          </span>
         <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        <strong>Company: InteliQuant AI Private Limited</strong> (“InteliQuant”,
        “Company”, “we”, “our”, “us”)
        <br />
        <strong>Platform: XynexAI Intelligence Platform</strong> (“Platform”,
        “XynexAI”, “Service”)
      </p>
      <p>
        InteliQuant AI Private Limited is committed to protecting your privacy
        and complying with all global data protection and AI governance laws.
        This Privacy Policy explains how we collect, use, share, store,
        transfer, and secure your information when you access or use{" "}
        <b>XynexAI</b>
      </p><br/>
      <p>
        By using XynexAI, you agree to the terms described in this Privacy
        Policy.
      </p>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>1. GLOBAL REGULATORY COMPLIANCE </strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        This Privacy Policy fully complies with:
      </p>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>✔ Privacy Regulations</strong>
      </h5>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>
          <b>EU GDPR (General Data Protection Regulation)</b>
        </li>
        <li>
          <b>UK GDPR (Data Protection Act 2018)</b>
        </li>
        <li>
          <b>California CCPA/CPRA</b>
        </li>
        <li>
          <b>
            US State Privacy Laws (Virginia, Colorado, Connecticut, Utah,
            Oregon)
          </b>
        </li>
        <li>
          <b>UAE PDPL (Federal Law No. 45 of 2021)</b>
        </li>
        <li>
          <b>Saudi Arabia PDPL (Royal Decree M/19 of 2021)</b>
        </li>
        <li>
          <b>India DPDP Act 2023</b>
        </li>
        <li>
          <b>Brazil LGPD</b>
        </li>
        <li>
          <b>Singapore PDPA</b>
        </li>
        <li>
          <b>Australia Privacy Act</b>
        </li>
        <li>
          <b>South Africa POPIA</b>
        </li>
        <li>
          <b>Canada PIPEDA</b>
        </li>
      </ul>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>✔ AI Governance Regulations</strong>
      </h5>

      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>
          <b>EU AI Act (2024–2026 mandatory requirements)</b>
        </li>
        <li>
          <b>OECD AI Principles</b>
        </li>
        <li>
          <b>NIST AI Risk Management Framework (US)</b>
        </li>
        <li>
          <b>UNESCO AI Ethics Framework</b>
        </li>
      </ul>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>✔ Security Certifications</strong>
      </h5>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>
          <b>ISO 27001 Information Security</b>
        </li>
        <li>
          <b>ISO 42001 AI Management Systems (AIMS)</b>
        </li>
        <li>
          <b>SOC 2 Type II</b>
        </li>
        <li>
          <b>Zero Trust Security Architecture</b>
        </li>
      </ul>

      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>✔ Global Data Transfer Laws</strong>
      </h5>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>EU Standard Contractual Clauses (SCCs)</li>
        <li>UK Transfer Addendum</li>
        <li>Data localization (Saudi Arabia, UAE Gov. sectors)</li>
        <li>Cross-border transfer safeguards (DPDP Act, LGPD, POPIA)</li>
      </ul>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong> 2. Information We Collect</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        We collect the following categories of data:
      </p>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>2.1 Information You Provide</strong>
      </h5>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>Name, email, contact details</li>
        <li>Company details</li>
        <li>User credentials and authentication details</li>
        <li>Files, documents, and datasets you upload</li>
        <li>User prompts, queries, and text inputs</li>
        <li>Support and communication data</li>
      </ul>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>2.2 Automatically Collected Information</strong>
      </h5>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>IP address, device identifiers</li>
        <li>Browser, OS, and device data</li>
        <li>Usage patterns and interaction logs</li>
        <li>Diagnostic and performance analytics</li>
      </ul>

      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>2.3 Sensitive Personal Data</strong>
      </h5>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        We <strong>do not intentionally collect</strong> sensitive data (health,
        biometrics, religion, etc.) unless explicitly required for a defined
        purpose and allowed by regional laws.
      </p>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>3. Purpose of Processing</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        We process data for the following purposes:
      </p>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>Delivering and improving the XynexAI platform</li>
        <li>Running AI/ML inference, analytics, and automation</li>
        <li>Providing customer support</li>
        <li>Enhancing security and preventing fraud</li>
        <li>Complying with legal obligations</li>
        <li>
          Training internal (non-customer) models for product improvements
        </li>
        <li>Ensuring safety and responsible use of AI</li>
        <li>Operational monitoring and system optimization</li>
      </ul>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        We do <b>not</b> sell your personal data.
      </p>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>4. AI, Machine Learning & Automated Decisions</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        XynexAI uses <b>Responsible AI principles.</b>:
      </p>
      <p>
        Where applicable, we provide{" "}
        <b> human oversight, transparency, and explainability, </b>as required
        by:
      </p>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>EU AI Act</li>
        <li>CCPA/CPRA automated decision-making rules</li>
        <li>OECD/NIST AI standards</li>
      </ul>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>AI Transparency Commitments</strong>
      </h5>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>
          Some outputs are generated by AI models using probability-based
          reasoning
        </li>
        <li>
          Synthetic or AI-generated content will be disclosed when required
        </li>
        <li>Users must not misuse AI to create deceptive content</li>
        <li>
          Deepfake generation requires explicit labeling and legal justification
        </li>
      </ul>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>No High-Risk AI Without Authorization</strong>
      </h5>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        The following require written approval:
      </p>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>Biometric identification</li>
        <li>Credit scoring</li>
        <li>Employment screening</li>
        <li>Health diagnostic predictions</li>
        <li>Public-sector decision-making</li>
      </ul>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        Prohibited uses include:
      </p>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>Social scoring</li>
        <li>Behavioral manipulation</li>
        <li>Unlawful surveillance</li>
      </ul>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>5. Legal Basis for Processing</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        Depending on region:
      </p>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>GDPR / UK-GDPR</strong>
      </h5>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>We agree to:</p>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>Performance of a contract</li>
        <li>Legitimate interests</li>
        <li>Legal obligation</li>
        <li>Consent</li>
        <li>Public interest (where applicable)</li>
      </ul>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>CCPA/CPRA</strong>
      </h5>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>Commercial purposes</li>
        <li>Service provider exception</li>
        <li>No sale or sharing of personal data</li>
      </ul>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>UAE PDPL / Saudi PDPL / DPDP Act</strong>
      </h5>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>Consent</li>
        <li>Contractual necessity</li>
        <li>Compliance with legal obligations</li>
      </ul>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>6. International Data Transfers</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        We transfer data globally while following applicable laws:
      </p>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>EU-approved SCCs</li>
        <li>UK International Data Transfer Addendum</li>
        <li>Brazil LGPD adequacy requirements</li>
        <li>Canada PIPEDA safeguards</li>
        <li>APAC cross-border certifications</li>
        <li>India DPDP permitted transferss</li>
        <li>POPIA cross-border rules</li>
      </ul>

      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>Saudi PDPL & UAE Data Localization</strong>
      </h5>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        If required by law, personal data will be stored and processed{" "}
        <b>within the jurisdiction.</b>
      </p>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>7. Data Sharing & Third Parties</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        We may share data with:
      </p>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>Cloud hosting (AWS/Azure/GCP)</li>
        <li>AI inference providers (OpenAI Enterprise, Anthropic, etc.)</li>
        <li>Security and monitoring vendors</li>
        <li>Payment processors</li>
        <li>Legal or regulatory authorities</li>
        <li>Partners under strict Data Processing Agreements (DPAs)</li>
      </ul>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>We never:</strong>
      </h5>
      <ul className="ml-5 pl-1 mb-4 list-disc leading-relaxed">
        <li className="flex items-center gap-2">
          <X className="text-red-500" />
          Sell data
        </li>
        <li className="flex items-center gap-2">
          <X className="text-red-500" />
          Share data with advertisers
        </li>
        <li className="flex items-center gap-2">
          <X className="text-red-500" />
          Allow partners to train their models on your data
        </li>
      </ul>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>8. Your Privacy Rights</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        We honor <b>all global rights</b>, including:
      </p>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>GDPR / UK-GDPR Rights</strong>
      </h5>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>Right to access</li>
        <li>Right to correct</li>
        <li>Right to delete</li>
        <li>Right to restrict processing</li>
        <li>Right to data portability</li>
        <li>Right to object</li>
        <li>Right to withdraw consent</li>
      </ul>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>CCPA/CPRA Rights</strong>
      </h5>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>Right to know</li>
        <li>Right to delete</li>
        <li>Right to correct</li>
        <li>Right to opt-out of automated decision-making</li>
        <li>Right to limit use of sensitive data</li>
      </ul>

      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>India DPDP Rights</strong>
      </h5>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>Right to access</li>
        <li>Right to correction</li>
        <li>Right to erasure</li>
        <li>Right to grievance redressal</li>
      </ul>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>Other Global Rights</strong>
      </h5>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>Brazil LGPD: data portability, anonymization</li>
        <li>POPIA: correction, destruction</li>
        <li>Singapore PDPA: withdrawal of consent</li>
      </ul>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        You may exercise these rights by emailing:
      </p>
      <a
        href="mailto:privacy@inteliquantai.com"
        style={{
          marginBottom: "16px",
          lineHeight: "1.6",
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        <Mail />
        <span>privacy@inteliquantai.com</span>
      </a>
      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong> 9. Security Measures</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
       We employ:
      </p>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>AES-256 encryption at rest</li>
        <li>TLS 1.3 encryption in transit</li>
        <li>Zero Trust architecture</li>
        <li>Multi-factor authentication</li>
        <li>Network segmentation</li>
        <li>Role-based access controls</li>
        <li>24/7 SOC monitoring</li>
        <li>Annual third-party penetration tests</li>
        <li>ISO 27001 & SOC 2 Type II controls</li>
        <li>ISO 42001 AI governance compliance</li>
        <li>Automated anomaly detection systems</li>
      </ul>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
       No system is 100% secure, but XynexAI maintains the highest international standards.
      </p>
      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>10. Data Retention</strong>
      </h4>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>Personal data is kept only as long as necessary</li>
        <li>
          User data is deleted within{" "}
          <strong>30 days</strong> of account termination
        </li>
        <li>Longer retention may apply when legally required</li>
        <li>Anonymized data may be retained for analytics and safety</li>
      </ul>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong> 11. Children’s Data</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        XynexAI is not intended for children under <b>18</b>.
        We do not knowingly collect children’s data.
      </p>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong> 12. Your Responsibilities</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        You must:
      </p>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>Submit only lawful data</li>
        <li>Not upload sensitive personal data without legal basis</li>
        <li>Use XynexAI responsibly</li>
        <li>Comply with export control rules</li>
        <li>Avoid generating harmful or illegal content</li>
      </ul>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong> 13. Changes to This Policy</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        We may update this Privacy Policy to reflect:
      </p>
      <ul
        style={{
          marginLeft: "20px",
          marginBottom: "16px",
          lineHeight: "1.6",
          listStyleType: "disc",
        }}
      >
        <li>New legal requirements</li>
        <li>AI safety and governance updates</li>
        <li>Platform enhancements</li>
      </ul>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        We will notify users of material changes.
      </p>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong> 14. Contact Information</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        <strong>InteliQuant AI Private Limited</strong><br/>
        Office No. 12, 2nd Floor, Plot No. 34/a/1,<br/>
        Chopasni Jagir, Main Pal Road,<br/>
        Jodhpur, Rajasthan, India – 342008
      </p>
      <a
        href="mailto:privacy@inteliquantai.com"
        style={{
          marginBottom: "16px",
          lineHeight: "1.6",
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        <Mail />
        <span>privacy@inteliquantai.com</span>
      </a><br/>
      <a
        href="www.inteliquantai.com"
        style={{
          marginBottom: "16px",
          lineHeight: "1.6",
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        <Globe />
        <span>www.inteliquantai.com</span>
      </a>
      </section>
    </MainLayout>
  );
};

export default PrivacyPolicy;